import errorHandlerFactory from './errorHandler';
import axios from 'axios';


const errorHandler = errorHandlerFactory('An error occured when fetching status');

export const getSqlStatus = () => axios.get('/SystemInfo/GetSqlStatus')
    .then(r => r.data).catch(errorHandler);

export const getUserRole = () => axios.get('/SystemInfo/GetUserRole')
    .then(r => r.data).catch(errorHandler);

